import { FC } from 'react';

import InfoBlock, { InfoBlockProps } from '../../InfoBlock';
import WaveEventButtons from '../../WaveEventButtons';
import TemplateVideoSlider from '../TemplateVideoSlider';

import TemplateVideoSliderWithInfoWrapper, {
  InfoAndButtonsWrapper
} from './Wrapper';

export type TemplateVideoSliderWithInfoProps = {
  info: InfoBlockProps;
  onBack: () => void;
};

const TemplateVideoSliderWithInfo: FC<TemplateVideoSliderWithInfoProps> = ({
  info,
  onBack
}) => (
  <TemplateVideoSliderWithInfoWrapper>
    <TemplateVideoSlider />
    <InfoAndButtonsWrapper>
      <InfoBlock {...info} />
      <WaveEventButtons {...{ onBack }} />
    </InfoAndButtonsWrapper>
  </TemplateVideoSliderWithInfoWrapper>
);

export default TemplateVideoSliderWithInfo;
